import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { HasPermission } from '../../authorization/components/HasPermission';
import { AppPermissions } from '../../authorization/Permissions';
import { MongoConsoleStores } from '../stores';
import { STORE_MONGO_CONSOLE } from '../stores/constants';
import MongoConsolePanel from '../components/MongoConsolePanel';

const MongoConsolePage: React.FC<MongoConsoleStores> = ({ mongoConsoleUI: store }) => {
    if (!store) {
        return null;
    }
    return (
        <HasPermission permissionClaim={AppPermissions.CanExecuteMongoConsole}>
            <MongoConsolePanel store={store} />
        </HasPermission>
    );
};

export default inject(STORE_MONGO_CONSOLE)(observer(MongoConsolePage));
